<template>
  <div class="content-area">
    <div class="note-area">
      <b-notification type="is-warning" :closable="false" has-icon role="alert">
        1ファイルでもDLすると、90日後に本案件の全てのファイルが削除され、再DLできなくなります。
      </b-notification>
    </div>
    <div class="list-area">
      <ul>
        <li v-for="file in targetRowData.reportFileList" :key="file.value">
          <a v-if="!file.s3DeleteFlag" @click="downloadFile(file.fileAddress, file.fileId)">
            <b-icon icon="paperclip" />{{ file.fileName }}
          </a>
          <span v-if="file.downloadFlag && !file.s3DeleteFlag" class="download"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    targetRowData: {},
  },
  methods: {
    downloadFile(fileAddress, fileId) {
      const THIS = this;

      this.apiCall(
        (client) => {
          return client.apis.apiCommon.getDownloadFilePOST({
            body: {
              fileId: fileId,
              fileName: fileAddress,
            },
          });
        },
        (result) => {
          var downloadUrl = result.obj.downloadUrl;
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = downloadUrl;

          var targetFile = fileAddress.toLowerCase();
          if (targetFile.endsWith(".pdf")) {
            a.target = "_blank";
          }

          THIS.$emit("download", fileId, result.obj.requestDLFlag);
          a.click();
          a.remove();

          THIS.$emit(
            "showDetail",
            THIS.targetRowData.detailKind,
            THIS.targetRowData.progress,
            THIS.targetRowData,
            true
          );
        },
        (error) => {
          THIS.showErrorMessage(error);
        }
      );
    },
  },
};
</script>

<style scoped>
.content-area {
  margin: 20px;
}
.note-area {
  margin-bottom: 20px;
}
.list-area {
  text-align: left;
}
.list-area li {
  margin: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/components/FileListHospitalDialog.vue